<template>
	<svg 
		:fill="color"
		width="18"
		height="18"
		viewBox="0 0 36 36"
		version="1.1" 
		preserveAspectRatio="xMidYMid meet"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		@click="$emit('click')">
		<title>trash-solid</title>
		<path class="clr-i-solid clr-i-solid-path-1" d="M6,9V31a2.93,2.93,0,0,0,2.86,3H27.09A2.93,2.93,0,0,0,30,31V9Zm9,20H13V14h2Zm8,0H21V14h2Z"></path><path class="clr-i-solid clr-i-solid-path-2" d="M30.73,5H23V4A2,2,0,0,0,21,2h-6.2A2,2,0,0,0,13,4V5H5A1,1,0,1,0,5,7H30.73a1,1,0,0,0,0-2Z"></path>
		<rect x="0" y="0" width="36" height="36" fill-opacity="0"/>
	</svg>
</template>

<script>
	export default {
		name: 'trash-icon-new',
		props: {
			color: {
				type: String,
				default: 'primary',
			},
		},
	};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/modules/shared/components/icons/trash-icon-new.vue